<script>
   import { Router, Route, Link } from "svelte-routing";
   import Home from "./routes/home.svelte";
   import TermsPrivacy from "./routes/terms-privacy.svelte";
   export let url = "";
 </script>
 
 <Router url="{url}">
    <Route path="/"><Home /></Route>
    <Route path="terms-privacy" component="{TermsPrivacy}" />
 </Router>
